module.exports = __webpack_public_path__ + "img/Enston-favicon.4dc9499a.png";